// extracted by mini-css-extract-plugin
export default {"card":"ManageItem_card__r2RY8"};